import React from "react";

import { CloseRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";
import { DateTime } from "luxon";

import useFirebase from "../../../../../config/context/firebaseContext";

import useBus from "../../context";

import { Constants } from "../../../../../config/constants";
import { GreyPallet } from "../../../../../config/styles";

import MainText from "../../../../../components/MainText";
import { ModalTransition } from "../../../../../components/ModalTransition";
import PageHeader from "../../../../../components/PageHeader";
import { NextBusesRequiredProps } from "../FavoriteStop";

import { BusStopListIdsType } from "../../../../../types/bus";
import { ModalBaseType } from "../../../../../types/common";

import { WideDialog } from "../../../../../components/MainModalSimple/styles";
import { StyledChip } from "../../../../../components/StyledComponents";

export type ModalNextBusesProps = ModalBaseType & { data: NextBusesRequiredProps };

export default function ModalNextBuses({ onClose, data }: ModalNextBusesProps) {
  const { analyticLog } = useFirebase();

  const { busSchedules, busStopTimes, CUSTOM_NOW } = useBus();

  const [open, setOpen] = React.useState(true);

  const [haveScroll, setHaveScroll] = React.useState(false);

  const ScrollBoxRef = React.useRef(null);
  const CurrentChipRef = React.useRef(null);

  const timeNow = DateTime.fromJSDate(data.timeNow).toFormat("HH:mm");
  const timeNext = DateTime.fromJSDate(data.timeNow)
    .plus({ minutes: parseInt(data.nextTime) })
    .toFormat("HH:mm");

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  const handleScrollTo = () => {
    if (haveScroll) return;

    if (CurrentChipRef.current && ScrollBoxRef.current) {
      const selectedOffset = (CurrentChipRef?.current as any)?.offsetTop - 100;
      (ScrollBoxRef?.current as any)?.scrollTo({ top: selectedOffset, behavior: "smooth" });
      setHaveScroll(true);
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      handleScrollTo();
    }, 260);

    analyticLog("click_next_bus", { bus: data.busId });
  }, []);

  React.useEffect(() => {
    handleScrollTo();
  }, [CurrentChipRef.current, ScrollBoxRef.current]);

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent sx={{ overflowY: "scroll" }} ref={ScrollBoxRef}>
        <PageHeader
          size="subtitle"
          title={"Horários"}
          rightIcon={<CloseRounded />}
          onRightAction={handleClose}
        />

        <Box mb={1}>
          <MainText size="small" color="regular">
            Próximos{" "}
            <b style={{ color: GreyPallet.Black, whiteSpace: "nowrap" }}>
              {busSchedules[data.busId].name}
            </b>{" "}
            na parada{" "}
            <b style={{ color: GreyPallet.Black, whiteSpace: "nowrap" }}>
              {Constants.busStopListMap[data.stopIndex as BusStopListIdsType].name}
            </b>
          </MainText>
        </Box>

        <Box display={"flex"} justifyContent={"center"} flexDirection={"column"} gap={1}>
          {!!Object.keys(busSchedules[data?.busId]?.schedule || {}) &&
            Object.keys(busSchedules[data.busId].schedule).map((hour) => {
              return Object.keys(busSchedules[data.busId].schedule?.[hour]).map((minute) => {
                let itTime = CUSTOM_NOW()
                  .set({ hour: parseInt(hour) })
                  .set({ minute: parseInt(minute) });

                if (data.stopIndex) {
                  itTime = itTime.plus({
                    minutes: parseInt(busStopTimes[data.stopIndex]?.[data.busId] || "0"),
                  });
                }

                const itTimeString = itTime.toFormat("HH:mm");

                return timeNow > itTimeString ? (
                  <StyledChip
                    chipcolor={busSchedules[data.busId].color}
                    key={itTimeString}
                    sx={{ opacity: 0.5 }}
                    label={itTimeString}
                  />
                ) : (
                  <StyledChip
                    chipcolor={busSchedules[data.busId].color}
                    key={itTimeString}
                    ref={timeNext === itTimeString ? CurrentChipRef : undefined}
                    label={itTimeString}
                  />
                );
              });
            })}
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
